module.exports = __webpack_public_path__ + "static/media/Airbrush.3121ba2c.ttf";